import { render } from "./IconEditorCmp.vue?vue&type=template&id=b676c18e"
import script from "./IconEditorCmp.vue?vue&type=script&lang=js"
export * from "./IconEditorCmp.vue?vue&type=script&lang=js"

import "./IconEditorCmp.vue?vue&type=style&index=0&id=b676c18e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__